<template>
<div class="alert alert-warning" :class="{'d-none': !show, 'd-block':show}">
{{ $t('booking.noDeliveryToSelectedCountry') }}
</div>
</template>

<script>
export default {
    name: 'NoDeliveryInCountryWarning',
    props: ['countries', 'country'],
    computed: {
        show() {
            if(this.country !== null && this.country !== undefined){
                return this.countries.filter((x) => x.code === this.country).length <= 0
            }
            return false;
        }
    }
}
</script>
